<script lang="ts">
	import { SubscriptionMenu } from "@entitlements/client"
	import { LoadingSpinner } from "misc-ui"
	import { getSubscriptionManager } from "../../../../modules/subscription-management/SubscriptionManager.svelte"
	import { LUX_AI_SUBSCRIPTION_LINK } from "../../../../modules/subscription-management/subscriptionLinks"
	import { LuxStudioIcon } from "@lux-ai/client"

	let subscriptionManager = getSubscriptionManager()
	let loadingPromise = $derived(subscriptionManager.loadingPromise)
	let luxAiSubscription = $derived(
		subscriptionManager.subscriptions.find((sub) => sub.type === "LUX_AI_ANNUAL"),
	)

	function onSubscribeClick() {
		window.open(LUX_AI_SUBSCRIPTION_LINK, "_blank")
	}
</script>

<div class="subscription-container">
	{#await loadingPromise}
		<LoadingSpinner height="6rem" color="var(--color-main)" />
	{:then}
		<SubscriptionMenu
			title="LuxStudio Subscription"
			description="Our AI transforms curated themes into personalized visuals, analyzing your space to create content perfectly mapped to your environment. The result is a one-of-a-kind immersive display that makes any space unforgettable."
			unitType="tokens"
			subscriptionCopy={[
				"Subscribe to unlock endless themes and spark new creative possibilities.",
			]}
			onSubscribe={() => onSubscribeClick()}
			activeSubscription={luxAiSubscription}
		>
			{#snippet heading()}
				<div class="heading-icon">
					<LuxStudioIcon strokeColor="var(--color-text-light)" />
				</div>
			{/snippet}
		</SubscriptionMenu>
	{/await}
</div>

<style>
	.heading-icon {
		height: 3rem;
		width: fit-content;
	}
</style>
